import { useConfirm } from '@estac1/ui';
import { useRef } from 'react';
import { usePricingForm } from './use-pricing-form.js';
import { usePricingSettingsQueries } from './use-pricing-settings-queries.js';

export const usePricingSettings = () => {
  const recalcConfirm = useConfirm();
  const dirtyRef = useRef(false);

  const { settings, audit, drift, recalc, save } = usePricingSettingsQueries(() => {
    dirtyRef.current = false;
  });

  const form = usePricingForm({
    settingsData: settings.data,
    auditEntries: audit.data?.entries,
    dirtyRef,
    save,
  });

  return {
    settings,
    audit,
    drift,
    recalc,
    recalcConfirm,
    tiers: form.tiers,
    minimumCents: form.minimumCents,
    maxVacancies: form.maxVacancies,
    trialDays: form.trialDays,
    previewVacancies: form.previewVacancies,
    expandedHistory: form.expandedHistory,
    validationError: form.validationError,
    previewSamples: form.previewSamples,
    pricingHistory: form.pricingHistory,
    save,
    setMinimumCents: form.setMinimumCents,
    setMaxVacancies: form.setMaxVacancies,
    setTrialDays: form.setTrialDays,
    setPreviewVacancies: form.setPreviewVacancies,
    toggleHistory: form.toggleHistory,
    updateTier: form.updateTier,
    addTier: form.addTier,
    removeTier: form.removeTier,
    handleSave: form.handleSave,
  };
};
